import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { StyleProp, ViewStyle } from 'react-native';
import { View } from 'react-native';
import type { TextInputProps } from 'react-native-paper';
import { HelperText, TextInput } from 'react-native-paper';

import { isEmptyOrNull } from '@/shared/utils/string';

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  helperText?: string;
  containerStyle?: StyleProp<ViewStyle>;
} & TextInputProps;

export const FormTextInput = <T extends FieldValues>({
  name,
  control,
  helperText,
  multiline = false,
  containerStyle,
  ...rest
}: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <View style={containerStyle}>
        <TextInput
          {...rest}
          multiline={multiline}
          value={value || ''}
          onChangeText={onChange}
          error={!!error}
          contentStyle={
            multiline
              ? { textAlignVertical: 'top' }
              : { textAlignVertical: 'center' }
          }
          style={[{ backgroundColor: 'transparent' }, rest.style]}
        />
        {isEmptyOrNull(error?.message) ? (
          !isEmptyOrNull(helperText) && (
            <HelperText type="info">{helperText}</HelperText>
          )
        ) : (
          <HelperText type="error">{error?.message}</HelperText>
        )}
      </View>
    )}
  />
);
